<!--
 * @Description: 新增短信模板
 * @Version: 1.0
 * @Autor: zhaoyy
 * @Date: 2022-02-15 11:07:35
 * @LastEditors: zhaoyy
 * @LastEditTime: 2022-02-17 17:55:35
-->
<template>
  <div class="add-sms-template">
    <div class="add-left">
      <el-form
        ref="form"
        :model="form"
        size="small"
        :rules="rules"
        label-position="left"
        label-width="90px"
      >
        <el-form-item label="模板名称" prop="templateName">
          <el-input
            v-model="form.templateName"
            placeholder="请输入模板名称"
            :maxlength="30"
            show-word-limit
            class="haslimit"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板类型" prop="templateType">
          <el-select v-model="form.templateType">
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板用途" prop="templateUse">
          <el-input
            v-model="form.templateUse"
            placeholder="请输入模板用途(用于模板审核)"
            :maxlength="20"
            show-word-limit
            class="haslimit"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板内容" prop="templateContent">
          <el-input
            ref="contentref"
            v-model="form.templateContent"
            type="textarea"
            @blur="handleInputBlur"
            placeholder="请输入短信内容"
            :maxlength="500"
          ></el-input>
        </el-form-item>
        <el-button type="primary" size="small" @click="commit">提交</el-button>
        <el-button size="small" @click="close">取消</el-button>
      </el-form>
    </div>
    <div class="add-right">
      <div class="right-title">
        <span class="title-name">可用变量索引</span>
        <span class="title-desc">点击变量可将其插入模板内容</span>
      </div>
      <div class="add-content">
        <div class="content-title">其他号码</div>
        <div class="content-items">
          <div
            class="content-item"
            v-for="(item, index) in otherNumberList"
            :key="index"
          >
            <span>{{ item.name }}</span>
            <el-button type="text" @click="addContent(item.value)">{{
              item.value
            }}</el-button>
          </div>
        </div>
        <div class="content-title">时间</div>
        <div class="content-items">
          <div
            class="content-item"
            v-for="(item, index) in timeList"
            :key="index"
          >
            <span>{{ item.name }}</span>
            <el-button type="text" @click="addContent(item.value)">{{
              item.value
            }}</el-button>
          </div>
        </div>
        <div class="content-title">金额</div>
        <div class="content-items">
          <div
            class="content-item"
            v-for="(item, index) in amountList"
            :key="index"
          >
            <span>{{ item.name }}</span>
            <el-button type="text" @click="addContent(item.value)">{{
              item.value
            }}</el-button>
          </div>
        </div>
        <div class="content-title">其他变量</div>
        <div class="content-items">
          <div
            class="content-item"
            v-for="(item, index) in otherVariablesList"
            :key="index"
          >
            <span>{{ item.name }}</span>
            <el-button type="text" @click="addContent(item.value)">{{
              item.value
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { RESPONSE_SUCCESS } from '@/constants'
export default {
  name: 'AddSmsTemplate',
  props: {
    showAddPage: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      form: {
        templateName: '',
        templateType: '1',
        templateUse: '',
        templateContent: ''
      },
      // 模板类型枚举(目前只需要显示通知类)
      typeList: [
        // { label: '验证码', value: '0' },
        { label: '通知类', value: '1' },
        // { label: '营销类', value: '2' }
      ],
      rules: {
        templateName: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        templateType: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        templateUse: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        templateContent: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ]
      },
      // 添加内容位置
      cursorIndex: 0,
      
      // 其他号码
      otherNumberList: [
        { name: '订单号', value: '${order}' },
        { name: '验证码', value: '${code}' },
        { name: '密码', value: '${password}' }
      ],
      // 时间
      timeList: [
        { name: '时间', value: '${time}' },
        { name: '日期', value: '${date}' },
        { name: '日', value: '${day}' },
        { name: '年', value: '${year}' },
        { name: '月', value: '${month}' }
      ],
      // 金额
      amountList: [{ name: '金额', value: '${money}' }],
      // 其他变量
      otherVariablesList: [
        { name: '姓名', value: '${name}' },
        { name: '地址', value: '${address}' },
        { name: '余额', value: '${account}' },
        { name: '短链接', value: '${url}' },
        { name: '快递公司', value: '${expressname}' },
        { name: '营业时间', value: '${businesshour}' }
      ]
    }
  },
  methods: {
    // 监控失去焦点时光标的位置
    handleInputBlur(e) {
      this.cursorIndex = e.srcElement.selectionStart
    },
    // 点击标签添加到模板内容中
    addContent(value) {
      let templateContent = ''
      if (this.form.templateContent.length > 0) {
        templateContent =
          this.form.templateContent.slice(0, this.cursorIndex) +
          value +
          this.form.templateContent.slice(this.cursorIndex)
      } else {
        templateContent = value
      }
      this.form.templateContent = templateContent.length > 500 ? templateContent.substring(0, 500) : templateContent
      // 添加后修改定位光标位置
      this.cursorIndex = this.cursorIndex + value.length
    },
    commit() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          const params = this.form
          const { code, msg } = await this.$API.smstemplateAdd(params)
          if (code === RESPONSE_SUCCESS) {
            this.$message.success('提交成功')
            this.close()
            this.$emit('commitAdd')
          } else {
            this.$message.warning(msg)
          }
        }
      })
    },
    close() {
      this.$emit('update:showAddPage', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.add-sms-template {
  display: flex;
  justify-content: space-between;
  ::v-deep .el-input {
    width: 100% !important;
  }
  .add-left {
    width: 450px;
    flex-shrink: 0;
    .haslimit {
      ::v-deep .el-input__inner {
        padding-right: 50px;
      }
    }
  }
  .add-right {
    width: calc(100% - 480px);
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    .right-title {
      display: flex;
      justify-content: space-between;
      padding: 10px 10px;
      font-size: 16px;
      line-height: 16px;
      align-items: center;
      background: #f9fafc;
      border-bottom: 1px solid #dcdfe6;
      color: #484848;
      .title-desc {
        font-size: 12px;
        color: #666;
      }
    }
    .add-content {
      padding: 10px;
      font-size: 14px;
      line-height: 2;
      .content-title {
        color: #000;
        font-weight: 800;
        // line-height: 2;
        margin-top: 10px;
      }
      .content-items {
        display: flex;
        flex-wrap: wrap;
        .content-item {
          margin-right: 30px;
          .el-button {
            padding: 0 !important;
          }
        }
      }
    }
  }
}
</style>
